import * as React from "react";
import type { SVGProps } from "react";
const SvgInvoices = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      fill="#23F6E7"
      d="M12.975 3.736c0-.958-.756-1.736-1.687-1.736h-6.6C3.755 2 3 2.778 3 3.736v8.896c.008.239.125.461.324.598l.931.642a.75.75 0 0 0 .84 0l1.247-.856 1.247.856a.75.75 0 0 0 .84 0l1.246-.856 1.247.856a.75.75 0 0 0 .84 0l.93-.642a.74.74 0 0 0 .308-.598V3.736zM10.39 9.69H5.635V8.483h4.755zm0-2.095H5.635V6.388h4.755zm0-2.019H5.635V4.37h4.755z"
    />
  </svg>
);
export default SvgInvoices;
